import { Route } from 'react-router';
import { ModuleGate } from '../../components/ModuleGate';
import type { BackofficeModule } from '../registry';
import { DocumentsPage } from './DocumentsPage';

/**
 * Einstiegspunkt des Moduls Dokumente im Backoffice (KON-163, Schlüssel `documents`): Dateien zu Kunden und Aufträgen. Die Speicherverwaltung dazu liegt in der Einrichtung
 * (pages/StoragePage.tsx), weil sie für alle Pakete gilt.
 */
export const documentsModule: BackofficeModule = {
  key: 'documents',
  path: '/dokumente',
  routes: <Route path="dokumente" element={<ModuleGate module="documents" permission="documents.read"><DocumentsPage /></ModuleGate>} />,
};
